import React from "react";

import DashboardLayout from "../layouts/Dashboard/Dashboard";

import { notifications } from "../components/Dashboard/testData";
import CustomerDataProvider2 from "../contexts/CustomerDataProvider";
import { setPageTitle } from "../utils/helpers";
import withFeatureFlags from "../components/FeatureFlags/withFeatureFlags";
import MyAccount2 from "../components/MyAccount/MyAccount";

import featureFlags from "../components/FeatureFlags/FeatureFlags";

const MyAccountPageContainer = () => {
  setPageTitle("Manage accounts | Investec Save");
  
  return (
    <>
      <CustomerDataProvider2>
        <DashboardLayout
          notifications={notifications}
          className="my-profile-page"
        >
          <MyAccount2 />
        </DashboardLayout>
      </CustomerDataProvider2>
    </>
  );
};

export default withFeatureFlags(MyAccountPageContainer);
